import { List, Map, fromJS} from 'immutable';
import * as constAction from 'root/actionConstants';

import { listFindByMapId } from 'core/generalFunctions';

const defaultState = Map({
  lista: List(),
  viajeAEliminar: Map()
});

export default function reducer(state=defaultState, action) {
  switch (action.type) {
    case constAction.FERIADOS_CLEAR: {
      if(action.payload === 'all')
      return defaultState;
      else if(defaultState.has(action.payload))
      return state.set(action.payload, defaultState.get(action.payload));
      else {
        console.error('No existe la propiedad '+action.payload);
        return state;
      }
    }
    case constAction.FERIADOS_SET_STATE: {
      let newState = state;
      for (var key in action.payload) newState = newState.set(key, fromJS(action.payload[key]));
      return newState;
    }
    case constAction.FERIADOS_DELETE:{
      let lista = state.get('lista');
      let index = listFindByMapId(lista, action.payload, true);
      lista = lista.delete(index);
      return state.set('lista', lista);
    }
    case constAction.FERIADOS_SET_STATE_BY_ID:{
      let lista = state.get('lista');
      lista = lista.push(Map(action.payload)).sortBy(feriado => feriado.get('fecha'));
      return state.set('lista', lista);
    }
  }
  return state;
}



// WEBPACK FOOTER //
// src/modules/feriados/reducer.js